import axios from '../../axios/axios.js';

const util = {
  restructureComments(data) {
    return data.map(el => {
      return {
        member_id: el.author_id,
        full_name: el.author_name,
        comment_body: el.body,
        link: el.profile_pic.link,
        timestamp: el.date,
        com_media_link: el.medias == null ? null : el.medias[0].link,
        communityMembers: null,
        numOfResponses: el.num_of_comments,
        comment_id: el.comment_id,
        medias: el.medias ? el.medias : []
      };
    });
  },
  restructureEvent(data) {
    return data.map(el => {
      return {
        postId: el.post_id,
        eventId: el.event_id,
        authorId: el.author_id,
        authorName: el.author_name,
        profilePictureURL: el.profile_pic.link,
        body: el.body,
        numOfComments: el.num_of_comments,
        active: Date.parse(el.date_to) > new Date() ? 'Aktivno' : 'Neaktivno',
        dateFrom: el.date_from,
        dateTo: el.date_to,
        createdDate: el.time,
        location: el.location,
        locationGpsLat: el.location_gps_lat,
        locationGpsLong: el.location_gps_long,
        medias: el.medias ? el.medias : [],
        status: el.status,
        divDescription: el.div_description,
        memberWillAttend: el.member_will_attend,
        is_pinned: el.is_pinned
      };
    });
  }
};

export default {
  state: {
    basicInfo: null,
    eventDetails: '',
    comments: null,
    userPicUrl: '',
    attendancePoll: null,
    communityMembers: null,
    eventPresence: null
  },
  mutations: {
    setEventDetails(state, payload) {
      state.eventDetails = payload;
    },
    setBasicEventInfo(state, payload) {
      state.basicInfo = payload;
      localStorage.setItem('k-e-m', JSON.stringify(payload));
    },
    setComments(state, payload) {
      state.comments = payload;
    },
    setUserPicUrl(state, payload) {
      state.userPicUrl = payload;
    },
    setAttendancePoll(state, payload) {
      state.attendancePoll = payload;
    },
    setCommunityMembers(state, payload) {
      state.communityMembers = payload;
    },
    setEventPresence(state, payload) {
      state.eventPresence = payload;
    }
  },
  actions: {
    setBasicInfo(context, payload) {
      if (payload) {
        context.commit('setBasicEventInfo', payload);
        // context.commit('setPostTitle', payload.body, {
        //   root: true
        // });
        context.commit('setPostTitle', 'Događaj', {
          root: true
        });
      }
    },
    getEventDetails(context) {
      context.commit('loadingStarted', null, {
        root: true
      });
      axios
        .post('post/get-posts', {
          community_id: context.rootState.communities.activeCommunity.id,
          filter_type: '3',
          futureOrPast: 1,
          post_id: context.state.eventDetails.postId
        })
        .then(({ data }) => {
          context.rootState.postTitle = data[0].body;

          let event = util.restructureEvent(data)[0];

          context.commit('setEventDetails', event);
          context.dispatch('getEventComments');
          context.dispatch('getEventAttendancePoll');
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          context.commit('setEventDetails', '');
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    getEventComments(context) {
      context.commit('loadingStarted', null, {
        root: true
      });
      axios
        .post('post/get-comments', {
          community_id: context.rootState.communities.activeCommunity.id,
          post_id: context.state.eventDetails.postId,
          futureOrPast: 1,
          numOfPosts: 999
        })
        .then(({ data }) => {
          let restructuredComments = util.restructureComments(data);
          context.commit('setComments', restructuredComments);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          console.log(err);
          context.commit('loadingFinished', null, {
            root: true
          });
        });
    },
    getEventAttendancePoll(context) {
      context.commit('loadingStarted', null, {
        root: true
      });

      axios
        .post('event/get-event-attendance-poll', {
          event_id: context.state.eventDetails.eventId
        })
        .then(({ data }) => {
          context.commit('setAttendancePoll', data);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    getActiveMembersByCommunity(context) {
      context.commit('loadingStarted', null, {
        root: true
      });

      axios
        .post('member/get-members-by-community', {
          community_id: context.rootState.communities.activeCommunity.id,
          active: 1
        })
        .then(({ data }) => {
          let dummyData = [];
          dummyData.push(...data);
          dummyData.push(...data);
          dummyData.push(...data);

          context.commit('setCommunityMembers', data);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    getEventPresence(context) {
      context.commit('loadingStarted', null, {
        root: true
      });

      axios
        .post('post/get-event-presence', {
          event_id: context.state.eventDetails.eventId
        })
        .then(({ data }) => {
          context.commit('setEventPresence', data.attended);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          console.log(err);
          context.commit('loadingFinished', null, {
            root: true
          });
        });
    }
  },
  getters: {},
  namespaced: true
};
